import { request } from './client';

/**
 * Everyone you have shared a game with, most-played-with first.
 *
 * Derived from game rosters rather than stored, so it is never stale. It is also
 * the only way to see another player — and it is mutually gated: they appear
 * because you played alongside them.
 */
export function getPlayedWith() {
  return request('/api/customer/players/me/played-with');
}
